const root = '/marketplace/submissions';

export const marketplaceOperationsPaths = {
  submissions: () => root,
  approve: (slug) => `${root}/${encodeURIComponent(slug)}/approve`,
  reject: (slug) => `${root}/${encodeURIComponent(slug)}/reject`,
};
